<template>
  <div class="anli align">
    <h2 :class="dongxiao == 3 ? 'fade-bottom' : ''">
      典型案例
      <div class="jieshao">为经济社会持续发展提供信息化服务</div>
    </h2>
    <div class="anli-lunbo">
      <el-carousel
        indicator-position="none"
        arrow="never"
        @change="change"
        ref="carousel"
        :interval="3000"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <div class="box" @mouseover="yiru(item)" @mouseout="yichu(item)">
            <div class="left" :class="dongxiao == 3 ? 'left-enter' : ''">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="text">
                {{
                  item.text.length > 194
                    ? item.text.slice(0, 191) + "..."
                    : item.text
                }}
              </div>
              <div class="line" ref="line"></div>
              <div class="gengduo" @click="gotomore(item)">
                了解更多
                <i class="el-icon-right"></i>
              </div>
            </div>
            <div class="right" :class="dongxiao == 3 ? 'right-enter' : ''">
              <img
                class="img"
                :src="item.imgs[0].src"
                alt=""
                @click="gotomore(item)"
              />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="qiehuan" :class="dongxiao == 3 ? 'right-enter' : ''">
        <div
          class="son"
          v-for="(item, index) in list"
          :key="index"
          :class="i == item.i ? 'active' : ''"
          @click="goto(item)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dongxiao"],
  data() {
    return {
      list: [
        {
          i: 1,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "智慧蓉城水务城运分中心V1",
          text: "市水务局深入贯彻落实“智慧蓉城”建设工作部署，按照“统一规划、统一标准、统筹项目、分工负责、分块实施、分步推进”的“三统三分”建设思路，以“一个数字底座、一张网、一个平台、五大板块”为总体框架，围绕新质生产力发展和绿色低碳创新等要求统筹推进建设，推进智慧水务的跨越式发展,开启智慧化治水管水新模式。",
          imgs: [
            { src: require("../../../assets/imgs/anli/chengyun2.png") },
            { src: require("../../../assets/imgs/anli/chengyun1.png") },
            { src: require("../../../assets/imgs/anli/chengyun3.png") },
            { src: require("../../../assets/imgs/anli/chengyun4.png") },
            { src: require("../../../assets/imgs/anli/chengyun5.png") },
            // { src: require("../../../assets/imgs/anli/chengyun6.png") },
            // { src: require("../../../assets/imgs/anli/chengyun7.png") },
            // { src: require("../../../assets/imgs/anli/chengyun8.png") },
          ],
          kehu: "成都市水务局",
          city: "四川省成都市",
          type: 0,
        },
        {
          i: 2,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "智慧蓉城水务城运分中心V2",
          text: "市水务局深入贯彻落实“智慧蓉城”建设工作部署，按照“统一规划、统一标准、统筹项目、分工负责、分块实施、分步推进”的“三统三分”建设思路，以“一个数字底座、一张网、一个平台、五大板块”为总体框架，围绕新质生产力发展和绿色低碳创新等要求统筹推进建设，推进智慧水务的跨越式发展,开启智慧化治水管水新模式。",
          imgs: [
            { src: require("../../../assets/imgs/anli/chengyun22.png") },
            { src: require("../../../assets/imgs/anli/chengyun11.png") },
            { src: require("../../../assets/imgs/anli/chengyun33.png") },
            { src: require("../../../assets/imgs/anli/chengyun44.png") },
            { src: require("../../../assets/imgs/anli/chengyun55.png") },
            { src: require("../../../assets/imgs/anli/chengyun66.png") },
            { src: require("../../../assets/imgs/anli/chengyun77.png") },
            { src: require("../../../assets/imgs/anli/chengyun88.png") },
          ],
          kehu: "成都市水务局",
          city: "四川省成都市",
          type: 0,
        },
        {
          i: 3,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "供水数据接入和实时监测系统V2",
          text: "实现区县数据和实时监测数据接入，从水源地到水厂，总体供水到区域供水到小范围供水的全过程，全局面的水量水质的在线监控与预警预报。建设供水运行管理一张图。重点呈现供水水厂（站）各管理要素信息，如水厂（站）、供水区域、水源地、出厂水水质监测、水厂（站）运行状态、供水管网等，为供水主管部门实时了解水厂（站）供水情况和决策分析提供支撑。",
          imgs: [
            { src: require("../../../assets/imgs/anli/gongshui2.png") },
            { src: require("../../../assets/imgs/anli/gongshui1.png") },
            { src: require("../../../assets/imgs/anli/gongshui3.png") },
            { src: require("../../../assets/imgs/anli/gongshui4.png") },
            { src: require("../../../assets/imgs/anli/gongshui5.png") },
          ],
          kehu: "成都市水务局、成都市供排水监管中心、成都各区(市)县水务局、成都市各供水厂",
          city: "四川省成都市",
          type: 0,
        },
        {
          i: 4,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "排水数据接入和实时监测系统V2",
          text: "通过数据接入和填报，动态管理业务流程，且实现大屏对系统信息进行呈现，实现对排水专题图、排水管网、排口、排水户、城镇污水处理厂、再生水利用、下穿隧道、污泥处理和农村生活污水等专题信息的管理、统计和分析。",
          imgs: [
            { src: require("../../../assets/imgs/anli/paishui2.png") },
            { src: require("../../../assets/imgs/anli/paishui1.png") },
            { src: require("../../../assets/imgs/anli/paishui3.png") },
            { src: require("../../../assets/imgs/anli/paishui4.png") },
            { src: require("../../../assets/imgs/anli/paishui5.png") },
          ],
          kehu: "成都市水务局、成都市供排水监管中心、成都各区(市)县水务局、成都市各污水厂、兴蓉市政",
          city: "四川省成都市",
          type: 0,
        },
        {
          i: 5,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "智慧水务平台建设一期服务采购项目",
          text: "建设构建温江区智慧水务雏形，建设以智慧防汛、智慧河湖、智慧供水、智慧排水四大板块为基础的温江区智慧水务。积极响应国家政策，同时实现改变水务信息化水平严重滞后现状、改变传统管理服务模式，实现城市供排水业务、供排水设施的整体统筹归集、融合，提升集中监测，集中管理，集中控制，科学调度能力，提供科学化决策、精细化管理、智慧化应用技术手段，创新供排水业务的管理体制机制，全面提升温江区水务行业管理现代化水平。",
          imgs: [
            { src: require("../../../assets/imgs/anli/wenjiang2.png") },
            { src: require("../../../assets/imgs/anli/wenjiang1.png") },
            { src: require("../../../assets/imgs/anli/wenjiang3.png") },
            { src: require("../../../assets/imgs/anli/wenjiang4.png") },
            { src: require("../../../assets/imgs/anli/wenjiang5.png") },
          ],
          kehu: "温江市水务局【供水科、排水科及防汛办】 ，温江区城投顺源生态环境建设有限公司环境公司",
          city: "四川省成都市",
          type: 0,
        },
        {
          i: 6,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "崇州智慧水务项目",
          text: "通过夯实基础、融同连接、挖掘数据、加强感知、促进应用，搭建智慧水务总体架构，建设“一大脑、一张图、N 应用、一体系”，强化防汛减灾、河湖管理等难点问题，建成全域感知、动态监测、实时预警、协同管理和高效应用的智慧水务平台，达到监测、预警、调度和辅助决策全过程，有效支撑水务业务管理科学化精细化。",
          imgs: [
            { src: require("../../../assets/imgs/anli/chongzhou2.png") },
            { src: require("../../../assets/imgs/anli/chongzhou1.png") },
            { src: require("../../../assets/imgs/anli/chongzhou3.png") },
            { src: require("../../../assets/imgs/anli/chongzhou4.png") },
            { src: require("../../../assets/imgs/anli/chongzhou5.png") },
          ],
          kehu: "崇州市水务局",
          city: "四川省崇州市",
          type: 0,
        },
        {
          i: 7,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "防汛抗旱指挥中心升级改造服务项目",
          text: "本项目通过夯实基础、融同连接、挖掘数据、加强感知、促进应用，扩充完善青羊智慧水务总体架构，建成全域感知、动态监测、实时预警、协同管理和高效应用的智慧水务平台，构建“预报、预警、预演、预案”四预体系，达到监测、预警、调度和辅助决策全过程，有效支撑水务业务管理科学化精细化。",
          imgs: [
            { src: require("../../../assets/imgs/anli/qingyang2.png") },
            { src: require("../../../assets/imgs/anli/qingyang1.png") },
            { src: require("../../../assets/imgs/anli/qingyang3.png") },
            { src: require("../../../assets/imgs/anli/qingyang4.png") },
            { src: require("../../../assets/imgs/anli/qingyang5.png") },
          ],
          kehu: "成都市青羊区综合行政执法局",
          city: "四川省成都市青羊区",
          type: 0,
        },
        {
          i: 8,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "龙泉山城市森林公园多要素地质调查项目",
          text: "龙泉山城市森林公园地质信息系统建立在成都市城市地质信息系统基础上，实现森林公园地上地面地下数据一体化存储管理、查询统计、综合分析、二次开发利用及信息共享等功能。以地质调查成果信息服务、地质资料信息服务、地质调查信息化建设为核心，实现地面地下一体化管理，建设多专业、多参数立体地质数据输入、管理、可视化和分析评价为一体的城市森林公园地下空间决策分析平台。",
          imgs: [
            { src: require("../../../assets/imgs/anli/longquan2.png") },
            { src: require("../../../assets/imgs/anli/longquan1.png") },
            { src: require("../../../assets/imgs/anli/longquan3.png") },
            { src: require("../../../assets/imgs/anli/longquan4.png") },
            { src: require("../../../assets/imgs/anli/longquan5.png") },
          ],
          kehu: "龙泉山森林公园管委会",
          city: "四川省成都市龙泉驿区",
          type: 0,
        },
        {
          i: 9,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "新津智慧水务",
          text: "基于成都市水务局已建设的智慧水务数据信息平台数据，提取新津区域内的智慧防汛、智慧河湖、智慧供水、智慧排水数据。紧密结合成都市智慧水务的建设，为全面完成年度工作目标，推进有关工作任务，需搭建新津区智慧水务调度展示系统，该系统将汇聚基础数据、规划数据、设施数据、监管数据、维护数据等相关信息，通过模块提炼通晓水务基础设施的多重指标、基础属性、空间分布和实时动态等数据，从而体现规范化管理，为新津区的水务业务情况、防汛管控预警等业务提供重要的数据展示与决策支撑。健全完善的新津水务特色四大板块，统筹自然灾害、预警、预报信息资源，综合运用现代信息手段，拓展完善水务信息化建设，提升水务信息化覆盖面，达到智慧水务信息化建设一体化。",
          imgs: [
            { src: require("../../../assets/imgs/anli/xinjin2.png") },
            { src: require("../../../assets/imgs/anli/xinjin1.png") },
            { src: require("../../../assets/imgs/anli/xinjin3.png") },
            { src: require("../../../assets/imgs/anli/xinjin4.png") },
            { src: require("../../../assets/imgs/anli/xinjin5.png") },
          ],
          kehu: "新津水务局",
          city: "四川省成都市新津区",
          type: 0,
        },
        {
          i: 10,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "智慧水务六水数据信息平台",
          text: "以成都市城市大脑为基础，通过若干控制性重点水务信息化项目的建设整合和完善现有信息系统功能，全面接入以“六水”为代表的各业务功能打造全域感知的泛在感知系统，全量汇聚水务数据，强化数据挖掘在山洪预测、管网优化、水资源调度等领域的应用，实现全域感知（水质、水量等）、动态监测（各种水务设备和水利设施）、高效应用（多屏展示、GIS呈现等）的智慧水务平台。把具体业务系统分为水资源支撑模块、水安全保障模块、水净化提升模块、水生态修复模块、水管理创新模块及水文化传承模块，从而打造具有成都特色的业务系统。综合单位实际情况及工作的特殊性专门设计，使系统不仅在当前处于领先地位，而且能为今后的发展提供数据支撑。在功能设计、软件操作以及其它方面设身处地为用户着想，以用户为中心，设计以实用性为第一目的的系统。 采用面向用户的设计风格，设计满足人性化操作方式的展示系统。",
          imgs: [
            { src: require("../../../assets/imgs/anli/liushui (2).png") },
            { src: require("../../../assets/imgs/anli/liushui (1).png") },
            { src: require("../../../assets/imgs/anli/liushui (3).png") },
            { src: require("../../../assets/imgs/anli/liushui (4).png") },
            { src: require("../../../assets/imgs/anli/liushui (5).png") },
            { src: require("../../../assets/imgs/anli/liushui (6).png") },
            { src: require("../../../assets/imgs/anli/liushui (7).png") },
            { src: require("../../../assets/imgs/anli/liushui (8).png") },
            { src: require("../../../assets/imgs/anli/liushui (9).png") },
            { src: require("../../../assets/imgs/anli/liushui (10).png") },
          ],
          kehu: "成都市水务局",
          city: "四川省成都市",
          type: 0,
        },

        {
          i: 11,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "供水数据接入与实时监测系统",
          text: "经开水务利用新一代的GIS技术，构建高效、合理、实用的供水管网信息系统，为水司各项工作开展及后续信息化系统建设提供数据支撑，进而应用至巡检、抢维修等业务中，辅助各部分工作与管网数据进行紧密结合，从而实现更加精细化的管理，实现各类业务流程、分析结果、运营信息基于地图的可视化展现，辅助水司进行宏观决策、综合运营，实现城市供水管网智慧运作，最终实现龙泉驿自来水公司“智慧水务”的发展目标。",
          imgs: [
            { src: require("../../../assets/imgs/anli/gongshui-1.png") },
            { src: require("../../../assets/imgs/anli/gongshui-2.png") },
            { src: require("../../../assets/imgs/anli/gongshui-3.png") },
            { src: require("../../../assets/imgs/anli/gongshui-4.png") },
            { src: require("../../../assets/imgs/anli/gongshui-5.png") },
          ],
          kehu: "经开水务",
          city: "四川省成都市",
          type: 0,
        },
        {
          i: 12,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "排水数据接入与实时监测系统",
          text: "建设内容由综合信息展示系统、业务应用系统、排水GIS服务平台和排水系统数据库建设等构成验。",
          imgs: [
            { src: require("../../../assets/imgs/anli/paishui (1).png") },
            { src: require("../../../assets/imgs/anli/paishui (2).png") },
            { src: require("../../../assets/imgs/anli/paishui (3).png") },
            { src: require("../../../assets/imgs/anli/paishui (4).png") },
            { src: require("../../../assets/imgs/anli/paishui (5).png") },
          ],
          kehu: "成都市水务局",
          city: "四川省成都市",
          type: 0,
        },
        {
          i: 13,
          src: require("../../../assets/imgs/home/yingxiao.png"),
          title: "锦江绿道府河BIM信息系统",
          text: "以成都地形图为基础，通过3DBIM渲染技术数字还原整个26公里河道，让用户在线体验锦江绿道的真实魅力。同时也让管理者通过绿道的监测信息，实时监测河道点位状态，做好及时防范。同时，在系统上叠加相关河段的巡查信息，便于直观掌握26公里绿道日常运维情况。",
          imgs: [
            { src: require("../../../assets/imgs/anli/bim (1).png") },
            { src: require("../../../assets/imgs/anli/bim (2).png") },
            { src: require("../../../assets/imgs/anli/bim (3).png") },
            { src: require("../../../assets/imgs/anli/bim (4).png") },
            { src: require("../../../assets/imgs/anli/bim (5).png") },
            { src: require("../../../assets/imgs/anli/bim (6).png") },
            { src: require("../../../assets/imgs/anli/bim (7).png") },
            { src: require("../../../assets/imgs/anli/bim (8).png") },
            { src: require("../../../assets/imgs/anli/bim (9).png") },
            { src: require("../../../assets/imgs/anli/bim (10).png") },
            { src: require("../../../assets/imgs/anli/bim (11).png") },
            { src: require("../../../assets/imgs/anli/bim (12).png") },
            { src: require("../../../assets/imgs/anli/bim (13).png") },
            { src: require("../../../assets/imgs/anli/bim (14).png") },
          ],
          kehu: "成都市水务局",
          city: "四川省成都市",
          type: 0,
        },
      ],
      i: 0,
      line: false,
    };
  },
  methods: {
    change(val) {
      this.i = val;
    },
    goto(item) {
      this.$refs.carousel.setActiveItem(item.i);
    },
    yiru(val) {
      this.$refs.line[val.i].style.width = "100%";
    },
    yichu(val) {
      this.$refs.line[val.i].style.width = "0%";
    },
    gotomore(item) {
      this.$router.push({ name: "xiangqing", params: item });
    },
  },
};
</script>

<style lang="scss" scoped>
.anli {
  width: 1920px;
  height: 100%;
  background: url("../../../assets//imgs//home/anlibg.png");
  background-size: 100% 100%;
  padding-top: 104px;
  .anli-lunbo {
    width: 100%;
    height: 370px;
    margin-top: 138px;
    position: relative;
    .box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      .left {
        width: 590px;
        height: 100%;

        position: relative;
        .title {
          font-size: 28px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          line-height: 48px;
          color: #ffffff;
        }
        .text {
          font-size: 18px;
          font-family: Alibaba PuHuiTi Xi !important;
          font-weight: 400;
          line-height: 26px;
          color: #c4c4c4;
          margin-top: 60px;
        }
        .line {
          position: absolute;
          width: 0%;
          height: 1px;
          background-color: #ffffff;
          left: 0;
          top: 276px;
          transition: all 1.2s cubic-bezier(0.39, 0.575, 0.565, 1);
        }
        .gengduo {
          position: absolute;
          bottom: 0;
          left: 2px;
          width: 128px;
          height: 44px;
          border: 1px solid #ffffff;
          opacity: 1;
          display: flex;
          align-items: center;
          justify-content: space-around;
          font-family: Alibaba PuHuiTi Xi !important;
          cursor: pointer;
          opacity: 0.4;
        }
        .gengduo:hover {
          opacity: 1;
        }
      }
      .right {
        width: 664px;
        height: 100%;
        position: relative;
        overflow: hidden;
        .img {
          width: 100%;
          height: 100%;
          transition: all 0.6s linear;
        }
      }
    }

    .box:hover .right .img {
      transform: scale(1.1, 1.1);
    }
    .qiehuan {
      position: absolute;
      right: 0;
      bottom: -40px;
      display: flex;
      .son {
        width: 20px;
        height: 4px;
        background: rgba(255, 255, 255, 0.39);
        border-radius: 55px;
        margin-left: 4px;
        cursor: pointer;
      }
      .active {
        width: 40px;
        height: 4px;
        background: rgba(255, 255, 255, 1);
        border-radius: 55px;
      }
    }
  }
}

.biankuan {
  animation: kuan 1.5s linear both;
}

@keyframes kuan {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
</style>